/* =============================================================================
   SafeWake ONE · assets/price-dual.js — local-currency-first price display (v1.1 · 2026-09-05)
   -----------------------------------------------------------------------------
   Founder ruling 2026-09-05: base store currency = AED; show each price in the visitor's
   COUNTRY currency, with the AED amount faint underneath. Checkout charges what Shopify
   presents (AED where the local currency cannot be presented) — the faint line is the truth.

   Composes with the other lanes (never twins them):
     • display country ← ?sw_display=XX (display-only override, testing / store setting proof)
                         → <html data-country> (snippets/country-context.liquid, honours
                           settings.sw_primary_country on a single-country deployment)
                         → window.SWMarket.country
     • presented currency ← window.SWMarket.cartCurrency / currency (money-context) — what Liquid
                         actually rendered: AED on an AED store unless Shopify presents local
     • parse / format ← window.SWMoney (assets/money.js) when present; self-contained fallback
                         otherwise ("Shopify cents = price × 100 for every currency")
     • config ← window.SWPriceDual (snippets/price-dual.liquid part:'head'): pegged AED→local rates
   Rewrites every known price element once, leaf by leaf (sale + compare-at, min – max ranges),
   then keeps them right through theme.js re-renders via a MutationObserver + loop guard.
   ============================================================================= */
(function (root, doc) {
  'use strict';
  var cfg = root.SWPriceDual;
  if (!cfg || !doc) return;

  var html = doc.documentElement;
  function market() { return root.SWMarket || {}; }
  function upper(s) { return s ? String(s).toUpperCase() : ''; }
  function param(name) { var m = new RegExp('[?&]' + name + '=([A-Za-z]{2})').exec(root.location.search); return m ? upper(m[1]) : ''; }
  function country() {
    return param('sw_display') || upper(html.getAttribute('data-country') || market().country || 'AE');
  }
  function presentedCurrency() {
    var m = market();
    return upper(m.cartCurrency || m.currency || html.getAttribute('data-currency') || cfg.base);
  }
  function dec(code) { return cfg.decimals[code] != null ? cfg.decimals[code] : 2; }

  /* ---- formatting (SWMoney when available, fallback otherwise) ---- */
  function group(intPart) { return intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function fmtAmount(amount, code) {
    /* money-sweep 2026-09-05: ONE formatter — assets/money.js does decimals/grouping (exact integer math); fallback below is offline-only */
    if (root.SWMoney && typeof root.SWMoney.formatAmount === 'function') {
      try { return root.SWMoney.formatAmount(root.SWMoney.fromDecimal(amount, code), code, { group: true }); } catch (e) {}
    }
    var d = dec(code), s = Number(amount).toFixed(d), parts = s.split('.');
    return group(parts[0]) + (d ? '.' + parts[1] : '');
  }
  function fmtLocal(amount, code) { return (cfg.formats[code] || (code + ' {a}')).replace('{a}', fmtAmount(amount, code)); }
  function fmtBase(amountAED) { return (cfg.baseLabel || 'AED {a}').replace('{a}', fmtAmount(amountAED, cfg.base)); }
  var AR = ['٠','١','٢','٣','٤','٥','٦','٧','٨','٩'];
  function fmtArabic(amount, code) {
    return fmtAmount(amount, code).replace(/\d/g, function (d) { return AR[+d]; }).replace(/,/g, '٬') + ' ' + (cfg.arabic[code] || code);
  }

  /* ---- parsing ---- */
  var TOKEN = /\d[\d,.٫٬]*\d|\d/g;
  var SYMBOLS = /(AED|Dhs\.?|KWD|KD|BHD|BD|OMR|OR|SAR|SR|QAR|QR|د\.إ|د\.ك|د\.ب|ر\.س|ر\.ق|ر\.ع\.)/g;
  function tokens(text) { return (String(text).match(TOKEN) || []); }
  function parseToken(tok, code) {
    if (root.SWMoney && typeof root.SWMoney.parse === 'function') {
      try { var c = root.SWMoney.parse(tok, code); if (typeof c === 'number' && !isNaN(c)) return root.SWMoney.toDecimal(c, code); } catch (e) {} /* money-sweep: no hardcoded divisor — cents-per-unit is calibrated from Liquid */
    }
    var raw = tok.replace(/٫/g, '.').replace(/٬/g, ',');
    var d = dec(code), lastSep = Math.max(raw.lastIndexOf('.'), raw.lastIndexOf(',')), num;
    if (lastSep === -1) num = raw;
    else {
      var tail = raw.slice(lastSep + 1);
      num = (tail.length === d && d > 0) ? raw.slice(0, lastSep).replace(/[.,]/g, '') + '.' + tail : raw.replace(/[.,]/g, '');
    }
    var v = parseFloat(num);
    return isNaN(v) ? null : v;
  }
  function suffixOf(text) { /* keep trailing words like " each" that are not currency symbols */
    var m = /(?:\d[\d,.٫٬]*)\s*([^\d]*)$/.exec(text);
    if (!m) return '';
    var rest = m[1].replace(SYMBOLS, '').replace(/[\s·]+$/, '').trim();
    return rest ? ' ' + rest : '';
  }

  /* ---- conversion ---- */
  var target, presented, showBase, chargedNote;
  function toAED(amount) { return presented === cfg.base ? amount : amount / (cfg.rates[presented] || 1); }
  function toLocal(amountAED) { return amountAED * (cfg.rates[target] || 1); }

  /* ---- DOM rewrite ---- */
  function targetNode(el) {
    if (el.matches && el.matches('.cart-drawer__row--total') && el.lastElementChild) return el.lastElementChild;
    return el;
  }
  function isOurs(node) { return node.classList && node.classList.contains('sw-price'); }
  /* one price-bearing string → { local, base } in the display currency (null when it holds no money) */
  function convert(text) {
    var toks = tokens(text);
    if (!toks.length) return null;
    var locals = [], bases = [];
    for (var t = 0; t < toks.length; t++) {
      var amount = parseToken(toks[t], presented);
      if (amount == null) continue;
      var aed = toAED(amount);
      locals.push(fmtLocal(toLocal(aed), target)); bases.push(fmtBase(aed));
    }
    if (!locals.length) return null;
    var sep = ' – ';
    return { local: locals.join(sep) + (toks.length === 1 ? suffixOf(text) : ''), base: bases.join(sep) };
  }
  function priceInner(c) {
    return '<span class="sw-price__local">' + c.local + '</span>' +
      (showBase ? '<span class="sw-price__base">' + c.base + '</span>' : '');
  }
  /* A host can carry its OWN price beside a priced child: Shopify serves the <s> compare-at only on
     some markets, and the 2026-09-06 Shopify-side parity run caught SA showing the raw AED sale price
     next to a converted compare-at on 178/265 cards (RESULTS.md addendum 17:55). It can equally carry
     children that hold no money at all (the bundle "Add · <price>" button: svg + label + price text).
     Both cases must keep their siblings and their DOM order, so every direct price-bearing TEXT NODE
     is wrapped in place — never innerHTML replacement, which would eat the <s> and the icon. */
  function renderOwnText(el, srcText) {
    if (el.getAttribute('data-sw-out') === el.textContent) return; /* our own output — loop guard */
    var nodes = el.childNodes, hit = false;
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.nodeType !== 3) continue;
      var val = node.nodeValue, c = convert(val);
      if (!c) continue;
      var head = val.slice(0, val.search(/\d/)).replace(SYMBOLS, ''); /* keep " · ", drop "Dhs." */
      var span = doc.createElement('span');
      span.className = 'sw-price';
      span.innerHTML = priceInner(c);
      if (chargedNote) span.setAttribute('title', 'Charged as ' + c.base + ' at checkout');
      node.nodeValue = head;
      el.insertBefore(span, node.nextSibling);
      if (/\s$/.test(val)) el.insertBefore(doc.createTextNode(' '), span.nextSibling);
      hit = true;
    }
    if (!hit) return;
    if (!el.getAttribute('data-sw-src')) el.setAttribute('data-sw-src', srcText);
    el.setAttribute('data-sw-out', el.textContent); /* guard on the WHOLE host, both parts rendered */
    el.setAttribute('data-sw-dual', '1');
  }
  function render(el) {
    el = targetNode(el);
    if (el.getAttribute('data-sw-dual') === 'liquid') return;
    var srcText = el.textContent || '';
    /* leaf-wise: when element children carry the money (sale + compare-at spans), rewrite each child */
    var kids = el.children, handled = false;
    for (var i = 0; i < kids.length; i++) {
      if (isOurs(kids[i])) { handled = true; continue; }
      if (tokens(kids[i].textContent).length) { render(kids[i]); handled = true; }
    }
    if (handled || kids.length) { renderOwnText(el, srcText); return; }
    var text = el.textContent || '';
    if (el.getAttribute('data-sw-out') === text) return; /* our own output — loop guard */
    var c = convert(text);
    if (!c) return;
    el.setAttribute('data-sw-src', text);
    el.innerHTML = '<span class="sw-price">' + priceInner(c) + '</span>';
    el.setAttribute('data-sw-out', el.textContent);
    el.setAttribute('data-sw-dual', '1');
    if (chargedNote) el.setAttribute('title', 'Charged as ' + c.base + ' at checkout');
  }
  function renderArabic(el) {
    var src = doc.querySelector('.product-info__price-current');
    if (!src) return;
    var toks = tokens(src.getAttribute('data-sw-src') || src.textContent);
    if (!toks.length) return;
    var amount = parseToken(toks[0], presented);
    if (amount == null) return;
    var out = ' · ' + fmtArabic(toLocal(toAED(amount)), target);
    if (el.getAttribute('data-sw-out') === el.textContent) return;
    el.textContent = out; el.setAttribute('data-sw-out', out);
  }
  function sweep() {
    for (var s = 0; s < cfg.selectors.length; s++) {
      var list = doc.querySelectorAll(cfg.selectors[s]);
      for (var i = 0; i < list.length; i++) render(list[i]);
    }
    if (cfg.arabicMirror) { var ar = doc.querySelectorAll(cfg.arabicMirror); for (var j = 0; j < ar.length; j++) renderArabic(ar[j]); }
  }

  var scheduled = false;
  function schedule() { if (scheduled) return; scheduled = true; root.requestAnimationFrame(function () { scheduled = false; sweep(); }); }
  function start() {
    target = cfg.countryCurrency[country()] || cfg.base;
    presented = presentedCurrency();
    /* WS-14 (money-lane relay via country-skins.md §4): the faint "Charged as AED" base line is only
       true when Shopify PRESENTS a different currency than the one displayed — wherever Shopify
       Payments presents the local currency (SAR/QAR per D-002) the customer is charged locally and
       the base line would lie. */
    /* 2026-09-08 founder ruling ("one price only"): the faint line is shown only for cfg.baseCountries (KW, QA);
       SA / OM / BH render the local amount alone. The charged-as tooltip stays wherever Shopify presents another currency. */
    showBase = presented !== target && (!cfg.baseCountries || cfg.baseCountries.indexOf(country()) !== -1);
    chargedNote = presented !== target;
    if (target === presented && target === cfg.base) return; /* AE on AED: nothing to add */
    sweep();
    try { new MutationObserver(schedule).observe(doc.body, { childList: true, subtree: true, characterData: true }); } catch (e) {}
    cfg.rendered = { country: country(), target: target, presented: presented, at: new Date().toISOString() };
    html.setAttribute('data-price-dual', target);
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start); else start();
  cfg.sweep = sweep;
})(window, document);
